import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../views/HomePage';
import CourseCenter from '../views/CourseCenter';
import CourseDetail from '../views/CourseCenter/CourseDetail.vue';
import CourseSearch from '../views/CourseCenter/CourseSearch.vue'

import NewsInfo from '../views/NewsInfo';
import TrainingBase from '../views/TrainingBase';
import TrainingBaseDetail from '../views/TrainingBase/components/Detail.vue';
import ExpertThinkTank from '../views/ExpertThinkTank';
import InfoBase from '../views/InfoBase';
import About from '../views/About';

import VideoPlayer from '../components/VideoPlayer';
import NewsDetail from '../views/NewsInfo/components/NewsDetail';
import ActiveDetail from '../views/NewsInfo/components/ActiveDetail';
import ExpertDetail from '../views/ExpertThinkTank/components/ExpertDetail.vue';
import InfoBaseDetail from '../views/InfoBase/components/Detail.vue';
import InfoDetail from '../views/InfoBase/components/InfoBaseDetail.vue';
import ExcellentWorks from '../views/ExcellentWorks/index.vue'
import WorkCompetition from "../views/WorkCompetition/index.vue";
import WorkCompetitionDetail from "../views/WorkCompetition/components/WorkCompetitionDetail.vue"
import WorkCompetitionSignUp from "../views/WorkCompetition/components/WorkCompetitionSignUp.vue";
import GraduateSignUp from "../views/WorkCompetition/components/GraduateSignUp.vue";
import WorkCompetitionEdit from "../views/WorkCompetition/components/WorkCompetitionEdit.vue"
import ContestDetail from "../views/ContestInfo/ContestDetail.vue";
import ContestApply from "../views/ContestInfo/ContestApply.vue";
import UserCenter from '../views/UserCenter';
import Exercise from '@/components/Exercise';
import Login from '../views/Login'
import ERROR from '../views/404'
import Order from '../views/Order/order.vue'
import OrderDetail from "../views/Order/orderDetail.vue";
import Examination from "../views/UserCenter/Examination.vue"

import BuyAgreement from "../views/Agreement/BuyAgreement.vue";
import RegisterAgreement from "../views/Agreement/RegisterAgreement.vue";
import VoteWorksAgreement from "../views/Agreement/VoteWorksAgreement.vue"
import $store from "../store";
import toLogin from "../utils/login";
import Introduce from "../views/WorkCompetition/introduce.vue"
import Graduation from "../views/WorkCompetition/Graduation.vue"
import SchoolWorks from "../views/School/SchoolWorks.vue"
import SchoolWorksDetail from "../views/School/SchoolWorksDetail.vue"
// 修复重复跳转时的 push 报错
const originalPush = VueRouter.prototype.push
// 忽略重复导航错误
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage,
        meta: {
            title: 'Home',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/404',
        name: '404',
        component: ERROR,
        meta: {
            title: '404',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/Login',
        name: 'Login',
        component: Login,
        meta: {
            title: 'Login',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/CourseCenter',
        name: 'CourseCenter',
        component: CourseCenter,
        meta: {
            title: 'Course Center',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/CourseDetail/:id',
        name: 'CourseDetail',
        component: CourseDetail,
        meta: {
            title: 'Course Detail',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/CourseSearch/:id',
        name: 'CourseSearch',
        component: CourseSearch,
        props:router=>({keyword:router.query.keyword}),
        meta: {
            title: 'Course Search',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/NewsInfo',
        name: 'NewsInfo',
        component: NewsInfo,
    },
    {
        path: '/TrainingBase',
        name: 'TrainingBase',
        component: TrainingBase,
        meta: {
            title: 'Training Base',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/TrainingBaseDetail',
        name: 'TrainingBaseDetail',
        component: TrainingBaseDetail,
        meta: {
            title: 'Training Base Detail',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/ExpertThinkTank',
        name: 'ExpertThinkTank',
        component: ExpertThinkTank,
    },
    {
        path: '/ExcellentWorks',
        name: 'ExcellentWorks',
        component: ExcellentWorks,
        meta: {
            title: 'Excellent Works',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/WorkCompetition',
        redirect: '/WorkCompetition/5',
    },
    {
        path: '/WorkCompetition/:id',
        name: 'WorkCompetition',
        component: WorkCompetition,
        meta: {
            title: 'Work Competition',
            requireAuth: false, // 是否需要登录
            hideLayout: false, // true 时隐藏顶部和底部布局
            keepAlive: true
        },
    },
    {
        path: '/WorkCompetitionDetail/:id',
        name: 'WorkCompetitionDetail',
        component: WorkCompetitionDetail,
        meta: {
            title: 'Work Competition Detail',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/ContestInfo/:contestId',
        name: 'ContestInfo',
        component: ContestDetail,
        meta: {
            title: 'Contest Info',
            requireAuth: false,
            hideLayout: false
        },
    },
    {
        path: '/ContestApply/:contestId',
        name: 'ContestApply',
        component: ContestApply,
        meta: {
            title: 'Contest Apply',
            requireAuth: true,
            hideLayout: false
        },
    },
    {
        path: '/WorkCompetitionSignUp/:id',
        name: 'WorkCompetitionSignUp',
        component: WorkCompetitionSignUp,
        meta: {
            title: 'Work Competition Sign Up',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/GraduateSignUp/:id',    // 旧报名页入口，统一跳转到新的赛事报名页
        name: 'GraduateSignUp',
        component: GraduateSignUp,
        meta: {
            title: 'Graduate Sign Up',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/WorkCompetitionEdit/:id',
        name: 'WorkCompetitionEdit',
        component: WorkCompetitionEdit,
        meta: {
            title: 'Work Competition Edit',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/InfoBase',
        name: 'InfoBase',
        component: InfoBase,
    },
    {
        path: '/About',
        name: 'About',
        component: About,
    },

    {
        path: '/NewsDetail',
        name: 'NewsDetail',
        component: NewsDetail,
    },
    {
        path: '/ActiveDetail',
        name: 'ActiveDetail',
        component: ActiveDetail,
    },
    {
        path: '/ExpertDetail',
        name: 'ExpertDetail',
        component: ExpertDetail,
    },
    {
        path: '/InfoBaseDetail',
        name: 'InfoBaseDetail',
        component: InfoBaseDetail,
    },
    {
        path: '/InfoDetail',
        name: 'InfoDetail',
        component: InfoDetail,
    },

    {
        path: '/UserCenter',
        name: 'UserCenter',
        component: UserCenter,
        meta: {
            title: 'User Center',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },

    {
        path: '/VideoPlayer',
        name: 'VideoPlayer',
        component: VideoPlayer,
        meta: {
            title: 'Video Player',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/Exercise',
        name: 'Exercise',
        component: Exercise,
    },
    {
        path: '/Order',
        name: 'Order',
        component: OrderDetail,
        meta: {
            title: 'Order',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/OrderDetail/:id',
        name: 'OrderDetail',
        component: OrderDetail,
        meta: {
            title: 'Order Detail',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/Examination/:id',
        name: 'Examination',
        component: Examination,
        meta: {
            title: 'Examination',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/CourseDetail/:id',
        name: 'CourseDetail',
        component: CourseDetail,
        meta: {
            title: 'Buy Agreement',
            requireAuth: true, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/BuyAgreement',
        name: 'BuyAgreement',
        component: BuyAgreement,
        meta: {
            title: 'Register Agreement',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/RegisterAgreement',
        name: 'RegisterAgreement',
        component: RegisterAgreement,
        meta: {
            title: 'Vote Works Agreement',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path: '/VoteWorksAgreement',
        name: 'VoteWorksAgreement',
        component: VoteWorksAgreement,
        meta: {
            title: 'Introduce',
            requireAuth: false, // 是否需要登录
            hideLayout: false // true 时隐藏顶部和底部布局
        },
    },
    {
        path:'/Introduce',
        name:'Introduce',
        component: Introduce,
        meta: {
            title: 'Graduation',
            requireAuth: true,
            hideLayout: false // true 时隐藏顶部和底部布局
        }
    },
    {
        path:'/Graduation',
        name:'Graduation',
        component: Graduation,
        meta: {
            title: 'School Works',
            requireAuth: false,
            hideLayout: false // true 时隐藏顶部和底部布局
        }
    },
    {
        path:'/SchoolWorks',
        name:'SchoolWorks',
        component: SchoolWorks,
        meta: {
            title: 'School Works Detail',
            requireAuth: true,
            hideLayout: true // true 时隐藏顶部和底部布局
        }
    },
    {
        path:'/SchoolWorksDetail',
        name:'SchoolWorksDetail',
        component: SchoolWorksDetail,
        meta: {
            title: 'School Works Detail',
            requireAuth: true,
            hideLayout: true // true 时隐藏顶部和底部布局
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
    if (to.path.startsWith('/WorkCompetitionSignUp/') || to.path.startsWith('/GraduateSignUp/')) {
        next(`/ContestApply/${to.params.id}`);
        return;
    }
    if (to.matched.length === 0) {
        next('/404');
        return;
    }

    const token = !!$store.state.app.token;
    const auth = !!to.meta.requireAuth;

    if (auth && !token) {
        if (from.name === 'Login') {
            next(false);
            return;
        }
        toLogin(true, to.fullPath);
        return;
    }

    if (!auth) {
        next();
        return;
    }

    $store.dispatch('USERINFO')
        .then(() => next())
        .catch((error) => {
            if (error && error.toLogin) {
                $store.commit('LOGOUT');
                localStorage.clear();
                toLogin(true, to.fullPath);
                return;
            }
            next();
        });
});
export default router;

